var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomViewWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2887_14764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2887_14764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2382 3V15.4426H11.8188V18.0435C11.7385 18.0132 11.6826 17.9962 11.6296 17.9716C9.84821 17.1483 8.06883 16.3204 6.28416 15.505C6.07381 15.4094 5.9984 15.2955 6.00003 15.0586C6.01144 13.2931 6.00818 11.5271 6.00859 9.76162C6.00859 7.59419 6.00777 5.42635 6.00736 3.25893C6.00736 3.17747 6.00736 3.09601 6.00736 3.00042H14.2382V3ZM13.6516 14.823C13.6516 14.7186 13.6516 14.6368 13.6516 14.5549C13.6516 10.9611 13.6503 7.36727 13.656 3.77346C13.656 3.59848 13.5953 3.56731 13.4437 3.56814C11.5212 3.57978 9.59873 3.58643 7.67627 3.59516C7.61308 3.59516 7.5499 3.60264 7.48671 3.6068C7.54012 3.66914 7.59759 3.70072 7.65711 3.72732C8.98359 4.315 10.3093 4.90393 11.6378 5.48662C11.767 5.54314 11.8176 5.61088 11.8171 5.7605C11.8123 8.70346 11.8131 11.646 11.8131 14.589C11.8131 14.6629 11.8131 14.7369 11.8131 14.823H13.6516ZM9.86207 12.641H10.7776V12.3222H10.1984V9.83975H10.8359C10.7854 9.70759 10.756 9.53386 10.7116 9.5297C10.4316 9.50435 10.1482 9.51682 9.86166 9.51682V12.6406L9.86207 12.641Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomViewWhite);
export default __webpack_public_path__ + "static/media/room_view_white.1278b6cbacd273aa8885402232bdc303.svg";
export { ForwardRef as ReactComponent };